export type { Product } from '@doist/email-renderer'
export { ProductProvider, useProduct } from '@doist/email-renderer'

export const todoist = 'todoist'
export const twist = 'twist'
export const automations = 'automations'
export const comms = 'comms'

const pathProducts = [automations, comms, twist] as const

export function getProductFromPath(pathname?: string) {
    return pathProducts.find((product) => pathname?.includes(`/${product}/`)) ?? todoist
}
